const MANAGE_CATALOG_ROLES = new Set(['OWNER', 'ADMIN', 'MANAGER'])

export function canManageCatalog(role: string | null | undefined): boolean {
  return role !== undefined && role !== null && MANAGE_CATALOG_ROLES.has(role)
}

const MANAGE_ORDERS_ROLES = new Set(['OWNER', 'ADMIN', 'MANAGER'])

export function canManageOrders(role: string | null | undefined): boolean {
  return role !== undefined && role !== null && MANAGE_ORDERS_ROLES.has(role)
}

const VIEW_CUSTOMERS_ROLES = new Set(['OWNER', 'ADMIN', 'MANAGER'])

export function canViewCustomers(role: string | null | undefined): boolean {
  return role !== undefined && role !== null && VIEW_CUSTOMERS_ROLES.has(role)
}

const MANAGE_SETTINGS_ROLES = new Set(['OWNER', 'ADMIN'])

export function canManageSettings(role: string | null | undefined): boolean {
  return role !== undefined && role !== null && MANAGE_SETTINGS_ROLES.has(role)
}

const VIEW_SETTINGS_ROLES = new Set(['OWNER', 'ADMIN', 'MANAGER', 'KITCHEN', 'COURIER'])

export function canViewSettings(role: string | null | undefined): boolean {
  return role !== undefined && role !== null && VIEW_SETTINGS_ROLES.has(role)
}

const PLATFORM_ADMIN_ROLES = new Set(['SUPERADMIN', 'ADMIN'])

export type PlatformAdminRole = 'SUPERADMIN' | 'ADMIN'

export function isPlatformAdminRole(
  role: string | null | undefined,
): role is PlatformAdminRole {
  return role !== undefined && role !== null && PLATFORM_ADMIN_ROLES.has(role)
}

export function isPlatformSuperadminRole(role: string | null | undefined): boolean {
  return role === 'SUPERADMIN'
}
